// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__gsmUL","btn":"styles_btn__MmYYV","info":"styles_info__41HYL"};